export default "__VITE_ASSET__VYsfg6o1__"